module.exports = __webpack_public_path__ + "img/appIcon-ui--arrowRight.f51fa6eb.svg";